import { render, staticRenderFns } from "./NewCustomers.vue?vue&type=template&id=11ecc8ac&scoped=true&"
import script from "./NewCustomers.vue?vue&type=script&lang=js&"
export * from "./NewCustomers.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomers.vue?vue&type=style&index=0&id=11ecc8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ecc8ac",
  null
  
)

export default component.exports